import PropTypes from 'prop-types'

/**
 * @typedef {Object} SharedOrderStatusLink
 * @property {string} [orderId]   - order id of the shared order.
 * @property {string} [link]    - Url for the order shared
 */

export const sharedOrderStatusLinkPropType = PropTypes.shape({
    orderId: PropTypes.string.isRequired,
    sharedLink: PropTypes.string.isRequired
})
